import React from 'react';
import {StyleSheet, Text, TouchableOpacity} from 'react-native';
import {colors} from 'src/assets';

export type Tab = {
  label: string;
  onPress?: () => void;
};

export type TabItemProps = Tab & {
  selected?: boolean;
};

export const TabItem: React.FC<TabItemProps> = ({label, selected, onPress}) => {
  return (
    <TouchableOpacity
      style={[styles.container, selected ? styles.selected : {}]}
      onPress={onPress}>
      <Text style={styles.text}>{label}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomWidth: 3,
    borderBottomColor: colors.white,
    paddingVertical: 12,
  },
  selected: {
    borderBottomColor: colors.chokuRed,
  },
  text: {
    fontSize: 15,
    fontWeight: '500',
    color: colors.chokuBlack,
  },
});
